/**
 * Module Index
 * 
 * Loads and registers all modules with the module registry.
 * This is the central entry point for module management.
 */
import moduleRegistry from './ModuleRegistry';
import EvaluationSchemaModule from './EvaluationSchemaModule';
import ConsultantModule from './ConsultantModule';
import PresentationModule from './PresentationModule';
import AnalyticsModule from './AnalyticsModule';

/**
 * Load and register all modules
 */
export const loadModules = (): void => {
    // Register EvalPro modules
    const evaluationSchemaModule = new EvaluationSchemaModule();
    moduleRegistry.register(evaluationSchemaModule);

    const consultantModule = new ConsultantModule();
    moduleRegistry.register(consultantModule);

    const presentationModule = new PresentationModule();
    moduleRegistry.register(presentationModule);

    const analyticsModule = new AnalyticsModule();
    moduleRegistry.register(analyticsModule);

    // Future modules can be registered here as they are developed
};

/**
 * Get the module registry instance
 * @returns {ModuleRegistry} The module registry instance
 */
export const getModuleRegistry = () => {
    return moduleRegistry;
};

/**
 * Initialize all modules
 */
export const initializeModules = async (): Promise<void> => {
    await moduleRegistry.initialize();
};

export default moduleRegistry;
